
import Component from "vue-class-component";
import Vue from "vue";
import {
    SysAdminHeaderNotificationClient, HeaderNotificationModel
} from "@/api-client";

import { NavigationGuardNext } from "vue-router/types/router";

import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import TrueFalseOptions from "@/features/shared/TrueFalseOptions";
import toasts from "@/components/Toasts";
import { Prop } from "vue-property-decorator";
import bus from "@/EventBus";


interface Props {
    model?: HeaderNotificationModel;
}

@Component({
    components: {
        SectionPageHeading,
    },

    async beforeRouteEnter(to, from, next: NavigationGuardNext<HeaderNotification>) {
        const props = to.meta!.props as Props;
        try {
            const result = await new SysAdminHeaderNotificationClient().item();
            if(result != null){
                props.model = result;
            }
            next();
        }
        catch (e) {
            next(e)
        }
    },
})
export default class HeaderNotification extends Vue implements Props {
    @Prop({ default: () => new HeaderNotificationModel({ id: null, title: "", message: "", titleEn: "", messageEn: "", isActive: false }) })
    model!: HeaderNotificationModel;

    yesNoOptions = TrueFalseOptions.options;

    save = () => {
        console.log(this.model);
        new SysAdminHeaderNotificationClient().update(this.model).then(() => {
            toasts.success(this.$ls.Global_Toast_SaveSuccess);
            bus.publish("header-notification-updated")
        }).catch(() => {
            toasts.failure(this.$ls.Global_Toast_FormSaveFailure);
        });
    }
}
